import { render } from "./ModalPricesUpdated.vue?vue&type=template&id=42a03624&scoped=true"
import script from "./ModalPricesUpdated.vue?vue&type=script&lang=js"
export * from "./ModalPricesUpdated.vue?vue&type=script&lang=js"

import "./ModalPricesUpdated.vue?vue&type=style&index=0&id=42a03624&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a03624"]])

export default __exports__